import GradeTile from './component.jsx'
export default GradeTile
